import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Chip } from '@mui/material';
import FilterBar from './FilterBar';

const statusStyle = (s) => {
  switch ((s || '').toUpperCase()) {
    case 'COMPLETE':  return { bgcolor: '#dcfce7', color: '#15803d' };
    case 'OPEN':      return { bgcolor: '#dbeafe', color: '#1d4ed8' };
    case 'REJECTED':  return { bgcolor: '#fee2e2', color: '#b91c1c' };
    case 'CANCELLED': return { bgcolor: '#f1f5f9', color: '#475569' };
    default:          return { bgcolor: '#fef3c7', color: '#b45309' };
  }
};
const txStyle = (t) =>
  (t || '').toUpperCase() === 'BUY'
    ? { bgcolor: '#dcfce7', color: '#15803d' }
    : { bgcolor: '#fee2e2', color: '#b91c1c' };

const CHIP = { fontWeight: 600, fontSize: '0.68rem', height: 20 };

const OrderTable = ({ orders }) => {
  const [filters, setFilters] = useState([]);

  const filterOptions = {
    status:           [...new Set(orders.map(o => o.status))].filter(Boolean),
    transaction_type: [...new Set(orders.map(o => o.transaction_type))].filter(Boolean),
    order_id:         [...new Set(orders.map(o => o.order_id))].filter(Boolean),
  };

  const columnLabels = {
    status:           'Status',
    transaction_type: 'Transaction Type',
    order_id:         'Order ID',
  };

  const addFilter    = (col, val) => setFilters(prev => [...prev.filter(f => f.column !== col), { column: col, value: val }]);
  const removeFilter = (col)      => setFilters(prev => prev.filter(f => f.column !== col));
  const clearFilters = ()         => setFilters([]);

  const filtered = orders.filter(o =>
    filters.every(f => {
      if (f.column === 'status')           return o.status === f.value;
      if (f.column === 'transaction_type') return o.transaction_type === f.value;
      if (f.column === 'order_id')         return o.order_id === f.value;
      return true;
    })
  );

  const getRowBg = (order) => {
    switch ((order.status || '').toUpperCase()) {
      case 'COMPLETE':  return '#e8f5e9';
      case 'OPEN':      return '#e3f2fd';
      case 'CANCELLED': return '#fef9c3';
      case 'REJECTED':  return '#fee2e2';
      default:          return undefined;
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <FilterBar
        filters={filters}
        filterOptions={filterOptions}
        columnLabels={columnLabels}
        onAdd={addFilter}
        onRemove={removeFilter}
        onClear={clearFilters}
      />
      <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Order ID</TableCell>
              <TableCell>Kite Symbol</TableCell>
              <TableCell>Shoonya Symbol</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.map((order, i) => (
              <TableRow
                key={i}
                sx={{
                  backgroundColor: getRowBg(order),
                  '&:hover': { backgroundColor: `${getRowBg(order) || '#f8fafc'} !important`, opacity: 0.95 },
                }}
              >
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{order.order_id}</TableCell>
                <TableCell sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{order.tradingsymbol}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{order.shoonya_symbol || 'N/A'}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 500 }}>{order.quantity}</TableCell>
                <TableCell align="right">{order.price}</TableCell>
                <TableCell>
                  <Chip label={order.transaction_type} size="small" sx={{ ...txStyle(order.transaction_type), ...CHIP }} />
                </TableCell>
                <TableCell>
                  <Chip label={order.status} size="small" sx={{ ...statusStyle(order.status), ...CHIP }} />
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{order.order_timestamp}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderTable;
